.form {
  display: grid;
  justify-items: start;
  gap: 10px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.check {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: var(--t-dense);
  color: var(--ink);
}

.confirm {
  display: grid;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--warn-line);
  border-radius: var(--radius);
  background: var(--warn-w);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
}

.saved {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-dense);
  line-height: 1.5;
}
